import React from 'react'

import { BaseEdge, type EdgeProps, getSmoothStepPath, useReactFlow } from '@xyflow/react'

import { EdgeUI, NodeUI } from 'modules/workflows/components/Node/types'

export const FlowDefaultEdge = ({
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  source,
}: EdgeProps) => {
  const { getNodes } = useReactFlow<NodeUI, EdgeUI>()
  const nodes = getNodes()
  const selectedNode = nodes.find((node) => node.selected)
  const color = source === selectedNode?.id ? '#69DAE5' : '#E4E4E4'

  // use smooth step path for better curves
  const [edgePath] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  })

  return (
    <>
      <BaseEdge path={edgePath} style={{ strokeWidth: 1.5, stroke: color }} />
    </>
  )
}
